import { render, staticRenderFns } from "./Funeraria.vue?vue&type=template&id=2d52e824&scoped=true"
import script from "./Funeraria.vue?vue&type=script&lang=js"
export * from "./Funeraria.vue?vue&type=script&lang=js"
import style0 from "./Funeraria.vue?vue&type=style&index=0&id=2d52e824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52e824",
  null
  
)

export default component.exports